<template>
  <pf-table compact striped>
    <pf-thead>
      <pf-tr>
        <pf-th>{{ $t('Descrizione') }}</pf-th>
        <pf-th>{{ $t('Qta') }}</pf-th>
        <pf-th>{{ $t('Prezzo') }}</pf-th>
        <pf-th>{{ $t('Sconto') }}</pf-th>
        <pf-th>{{ $t('IVA') }}</pf-th>
        <pf-th>{{ $t('Importo') }}</pf-th>
      </pf-tr>
    </pf-thead>
    <pf-tbody v-if="invoiceState.updating">
      <pf-tr>
        <pf-td><pf-skeleton width="50%" /></pf-td>
        <pf-td><pf-skeleton width="50px" /></pf-td>
        <pf-td><pf-skeleton width="30%" /></pf-td>
        <pf-td><pf-skeleton width="50px" /></pf-td>
        <pf-td><pf-skeleton width="80px" /></pf-td>
        <pf-td><pf-skeleton width="150px" /></pf-td>
      </pf-tr>
      <pf-tr>
        <pf-td><pf-skeleton width="80%" /></pf-td>
        <pf-td><pf-skeleton width="45px" /></pf-td>
        <pf-td><pf-skeleton width="60%" /></pf-td>
        <pf-td><pf-skeleton width="50px" /></pf-td>
        <pf-td><pf-skeleton width="70px" /></pf-td>
        <pf-td><pf-skeleton width="120px" /></pf-td>
      </pf-tr>
    </pf-tbody>
    <template v-else>
      <pf-tbody>
        <pf-tr v-for="row in invoice.rows" :key="row.id">
          <pf-td :data-label="$t('Descrizione')">{{ row.description }}</pf-td>
          <pf-td :data-label="$t('Qta')">{{ row.qt }}</pf-td>
          <pf-td :data-label="$t('Prezzo')">{{ $currency(row.price, invoice.currency) }}</pf-td>
          <pf-td :data-label="$t('Sconto')">{{ $currency(row.discount) }}%</pf-td>
          <pf-td :data-label="$t('IVA')">{{ row.vat }}%</pf-td>
          <pf-td :data-label="$t('Importo')">{{ $currency(row.amount, invoice.currency) }}</pf-td>
        </pf-tr>
      </pf-tbody>
      <tfoot>
        <pf-tr>
          <pf-th colspan="5" style="text-align: right">
            {{ $t('Imponibile') }}:

          </pf-th>
          <pf-td style="text-align: right">
            {{ $currency(invoice.amount, invoice.currency) }}
          </pf-td>
        </pf-tr>
        <pf-tr>
          <pf-th colspan="5" style="text-align: right">
            {{ $t('Imposta') }}:
          </pf-th>
          <pf-td style="text-align: right">
            {{ $currency(invoice.vatamount, invoice.currency) }}
          </pf-td>
        </pf-tr>
        <pf-tr>
          <pf-th colspan="5" style="text-align: right">
            <b>{{ $t('Totale') }}:</b>
          </pf-th>
          <pf-td style="text-align: right">
            {{ $currency(invoice.amount + invoice.vatamount, invoice.currency) }}
          </pf-td>
        </pf-tr>
      </tfoot>
    </template>
  </pf-table>
</template>

<script lang="ts" setup>
import { Resource } from '@/resources';
import { asyncComputed } from '@common/asyncComputed';

const props = defineProps<{
  invoiceId: number;
}>();

const { state: invoiceState, result: invoice } = asyncComputed(() => new Resource('invoices').get(props.invoiceId));
</script>
